import {
  requestGet,
  requestPost,
  requestPut,
  requestDelete,
  api,
} from "../config/Api";
import { downloadFilePost } from "./ReportService";

const base = "liquidations";

export const getAllLiquidations = (params) => requestGet(base, params);

export const getLiquidationsByLegalFile = (legalFileId) =>
  requestGet(`${base}/legal-file/${legalFileId}`);

export const calculateLiquidation = (legalFileId, data) =>
  requestPost(`${base}/legal-file/${legalFileId}/calculate`, data);

export const storeLiquidation = (legalFileId, data) =>
  requestPost(`${base}/legal-file/${legalFileId}`, data);

export const getLiquidation = (id) => requestGet(`${base}/${id}`);

export const updateLiquidation = (id, data) =>
  requestPut(`${base}/${id}`, data);

export const deleteLiquidation = (id) => requestDelete(`${base}/${id}`);

export const generateLiquidationPdf = (id) =>
  requestPost(`${base}/${id}/generate-pdf`, {});

export const fetchTributarioBalance = (params) =>
  requestGet(`${base}/tributario-balance`, params);

export const exportMunicipalitySheet = (payload) =>
  downloadFilePost(`${base}/report/municipality-sheet`, payload);

export const exportLiquidationSheet = (payload) =>
  downloadFilePost(`${base}/report/liquidation-sheet`, payload);

export const previewLiquidationHtml = async (id) => {
  const response = await api.get(`${base}/${id}/preview-html`, {
    responseType: "text",
  });
  return response.data;
};

// Catalog — simple lists & CRUD
export const getJusValues = (params) =>
  requestGet(`${base}/catalog/jus-values`, params);
export const createJusValue = (data) =>
  requestPost(`${base}/catalog/jus-values`, data);
export const updateJusValue = (id, data) =>
  requestPut(`${base}/catalog/jus-values/${id}`, data);
export const deleteJusValue = (id) =>
  requestDelete(`${base}/catalog/jus-values/${id}`);

export const getBarAssocValues = (params) =>
  requestGet(`${base}/catalog/bar-association-values`, params);
export const createBarAssocValue = (data) =>
  requestPost(`${base}/catalog/bar-association-values`, data);
export const updateBarAssocValue = (id, data) =>
  requestPut(`${base}/catalog/bar-association-values/${id}`, data);
export const deleteBarAssocValue = (id) =>
  requestDelete(`${base}/catalog/bar-association-values/${id}`);

export const getBarCollegeFees = (params) =>
  requestGet(`${base}/catalog/bar-college-fees`, params);
export const createBarCollegeFee = (data) =>
  requestPost(`${base}/catalog/bar-college-fees`, data);
export const updateBarCollegeFee = (id, data) =>
  requestPut(`${base}/catalog/bar-college-fees/${id}`, data);
export const deleteBarCollegeFee = (id) =>
  requestDelete(`${base}/catalog/bar-college-fees/${id}`);

export const getJusticeTaxRates = (params) =>
  requestGet(`${base}/catalog/justice-tax-rates`, params);
export const createJusticeTaxRate = (data) =>
  requestPost(`${base}/catalog/justice-tax-rates`, data);
export const updateJusticeTaxRate = (id, data) =>
  requestPut(`${base}/catalog/justice-tax-rates/${id}`, data);
export const deleteJusticeTaxRate = (id) =>
  requestDelete(`${base}/catalog/justice-tax-rates/${id}`);

export const getLiquidationItemTypes = (params) =>
  requestGet(`${base}/catalog/item-types`, params);
export const createLiquidationItemType = (data) =>
  requestPost(`${base}/catalog/item-types`, data);
export const updateLiquidationItemType = (id, data) =>
  requestPut(`${base}/catalog/item-types/${id}`, data);
export const deleteLiquidationItemType = (id) =>
  requestDelete(`${base}/catalog/item-types/${id}`);

export const updateSentenceRubros = (liquidationItemTypeIds) =>
  requestPut(`${base}/catalog/item-types/sentence-rubros`, {
    liquidation_item_type_ids: liquidationItemTypeIds,
  });

export const updateExecutionRubros = (liquidationItemTypeIds) =>
  requestPut(`${base}/catalog/item-types/execution-rubros`, {
    liquidation_item_type_ids: liquidationItemTypeIds,
  });

// Dependency (juzgado) item-type config
export const getDependenciesConfig = (params) =>
  requestGet(`${base}/catalog/dependencies`, params);
export const createDependency = (d) =>
  requestPost(`${base}/catalog/dependencies`, d);
export const updateDependency = (depId, d) =>
  requestPut(`${base}/catalog/dependencies/${depId}`, d);
export const getDependencyItemTypes = (depId) =>
  requestGet(`${base}/catalog/dependencies/${depId}/item-types`);
export const syncDependencyItemTypes = (depId, d) =>
  requestPut(`${base}/catalog/dependencies/${depId}/item-types`, d);
